import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui' // 引入Element
import 'element-ui/lib/theme-chalk/index.css'
import './assets/font/font.css'
// 导入字体图标
import './assets/fonts/iconfont.css'
import './assets/fonts/iconfont'
import echarts from 'echarts'
//import './assets/js/echarts.min.js'
import animated from 'animate.css' // 引入动画插件
import axios from 'axios'
import './assets/css/base.css'
import JsonExcel from 'vue-json-excel'
import drag from './util/drag'
import stopDrag from './util/stopDrag'
import promise from 'es6-promise';
import Cookies from 'js-cookie'
import VueDragResize from 'vue-drag-resize';
// 实现复制内容到用户粘贴板的功能
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

promise.polyfill();
Vue.use(ElementUI)
Vue.use(animated)
Vue.component('downloadExcel', JsonExcel)
Vue.prototype.Global = {}

Vue.prototype.Global._baseUrl = 'https://dapc1.scqwszfd.cn:8123/symainData2.ashx'
Vue.prototype.Global._baseUrl2 = 'https://dapc1.scqwszfd.cn:8123/syJdzf.ashx'
Vue.prototype.Global._baseUrl3 = 'https://xxswj.hzxhykj.com:9086'








// 回显专业类别
Vue.prototype.zylbLabel = function(datas, value) {
	var actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].ID == ('' + value)) {
			actions.push(datas[key].mc);
			return true;
		}
	})
	return actions.join('');
}
Vue.prototype.getDate = function (time, e){//全局函数1
       /**
        * time :date 类型 可以不传
        * e: 返回格式 yyyy-MM-dd hh:mm:ss (默认) ||  yyyy-MM-dd
        */
       let fmt = e || 'yyyy-MM-dd hh:mm:ss'
       let data = new Date(time || new Date())
       let o = {
           "M+": data.getMonth() + 1, //月份
           "d+": data.getDate(), //日
           "h+": data.getHours(), //小时
           "m+": data.getMinutes(), //分
           "s+": data.getSeconds(), //秒
           "q+": Math.floor((data.getMonth() + 3) / 3), //季度
           "S": data.getMilliseconds() //毫秒
       }
       if (/(y+)/.test(fmt)) {
           fmt = fmt.replace(RegExp.$1, (data.getFullYear() + "").substr(4 - RegExp.$1.length))
       }
       for (let k in o) {
           if (new RegExp("(" + k + ")").test(fmt)) {
               fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
           }
       }
       return fmt
};
Vue.prototype.getDate2 = function (time){//全局函数1
		let now = new Date(time || new Date());
		let year = now.getFullYear(); //得到年份
		let month = now.getMonth()+1;//得到月份
		let date = now.getDate();//得到日期
        month = month;
		// if (month < 10) month = "0" + month;
		// if (date < 10) date = "0" + date;
		let tm = year + "年" + month + "月" + date + "日";
		return tm; 
};
Vue.prototype.getEnd= function (){//全局函数1
		let now = new Date();
		let year = now.getFullYear(); //得到年份
		let month = now.getMonth();//得到月份
		let date = now.getDate();//得到日期
        month = month + 1;
		if (month < 10) month = "0" + month;
		if (date < 10) date = "0" + date;
		let time = year + "-" + month + "-" + date;
		return time; 
};
Vue.prototype.getNow= function (){//全局函数1
    let now = new Date();
    let year = now.getFullYear(); //得到年份
    let month = now.getMonth();//得到月份
    month = month + 1;
    if (month < 10) month = "0" + month;
    let time = year + "-" + month + "-" + "01";
    return time; 
};
Vue.prototype.getMoment= function (){//全局函数1
    let now = new Date();
    let year = now.getFullYear(); //得到年份
    let month = now.getMonth();//得到月份
    //let date = now.getDate();//得到日期
    let nextMonth = ++ month ;//得到下一个月
    //获取到下个月的第一天      
    let nextMonthFirstDay=new Date(now.getFullYear(),nextMonth,1);
    //一天时间的毫秒数
    let oneDay=1000*60*60*24;
    //let time = year + "-" + month + "-" + date;
    //return time; 
    //获取当前月第一天和最后一天
    //let firstDay = moment(monthStart).format("YYYY-MM-DD");
    //nextMonthFirstDay-oneDay表示下个月的第一天减一天时间的毫秒数就是本月的最后一天
     let lastDay = now.getDate(nextMonthFirstDay-oneDay);
     if (month < 10) month = "0" + month;
    if (lastDay < 10) lastDay = "0" + lastDay;
     let time = year + "-" + month + "-" + lastDay;
	 return time; 
};
// 计算两个日期的间隔天数    

Vue.prototype.Computation = function (sDate1,sDate2){     

    var aDate, oDate1, oDate2, iDays     
  
    aDate = sDate1.split("-")      
  
    oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])   //转换为12-13-2008格式      
  
    aDate = sDate2.split("-")      
  
    oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])      
  
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 /24)+1;   //把相差的毫秒数转换为天数      
  
    return iDays;

  }    

Vue.prototype.addZero= function (num){
    return num >= 10 ? '' + num : '0' + num
}

Vue.prototype.getYmdhmsByTime = function (time){
    const timeObj = new Date(time).getTime() ? new Date(time) : new Date();
    const year = timeObj.getFullYear();
    const month = addZero(timeObj.getMonth() + 1);
    const date = addZero(timeObj.getDate());
    const hour = addZero(timeObj.getHours());
    const minute = addZero(timeObj.getMinutes());
    const second = addZero(timeObj.getSeconds());
    return [year, month, date, hour, minute, second]
}



Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios  

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')